import {
	lazy,
} from 'react'

export const GamePageAsync = lazy(async() => {
	return import('./game.page')
})
